import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/" style={{ color: 'white', textDecoration: 'none' }}>
            EWS Analysis Tool
          </Link>
        </div>
        <div className="nav-links">
          <Link 
            to="/" 
            className={location.pathname === '/' ? 'active' : ''}
          >
            Upload
          </Link>
          <Link 
            to="/configs" 
            className={location.pathname === '/configs' ? 'active' : ''}
          >
            Configurations
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
